import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SlidersHolidays({ section }) {

  function updateClassBasedOnScreenSize() {
    const element = document.querySelector(".explre-holidays-page");

    if (!element) return;

    if (window.innerWidth >= 1024) {
      element.classList.add("pb-5");

    } else {
      element.classList.remove("pb-5");

    }
  }

  window.addEventListener("load", updateClassBasedOnScreenSize);
  window.addEventListener("resize", updateClassBasedOnScreenSize);

  const [isScrolled, setIsScrolled] = useState(false);

  const settings = {
    slidesToShow: 7, // Default number of slides to show
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: true,
    autoplaySpeed: 2000, // Adjusted for smoother transitions
    arrows: false, // Disable navigation arrows
    dots: false, // Disable dots
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024, // For screens smaller than 1024px
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768, // For screens smaller than 768px
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 520, // For screens smaller than 520px
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    setIsScrolled(scrollTop > 50);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);





  return (
    <section className="explre-holidays-page popular-state holidays-left">
      <div className="container">
        <div className="title">
          <h3>
            {section?.title_highlight ? <span>{section.title_highlight} </span> : <span>Explore </span>} {section?.title || 'Holidays By Theme'}
          </h3>
          <p className="mb-4">{section?.subtitle || 'Find your perfect getaway, tailored to your interests.'}</p>
        </div>

        <div
          className={`customer-logos slider slides-wrapper ${isScrolled ? "slide" : ""
            }`}
        >
          <Slider {...settings}>
            {(section?.Items?.length ? section.Items : [
              { title: 'Family Retreat', image_url: 'assets/img/tours/theme/family.png', link_url: '/holidays-list' },
              { title: 'Beach', image_url: 'assets/img/tours/theme/beach.png', link_url: '/holidays-list' },
              { title: 'Luxury', image_url: 'assets/img/tours/theme/luxury.png', link_url: '/holidays-list' },
              { title: 'Honeymoon', image_url: 'assets/img/tours/theme/honeymoon.png', link_url: '/holidays-list' },
              { title: 'Adventure', image_url: 'assets/img/tours/theme/adventure.png', link_url: '/holidays-list' },
              { title: 'Pilgrimage', image_url: 'assets/img/tours/theme/pilgrimage.png', link_url: '/holidays-list' },
              { title: 'Safari Trails', image_url: 'assets/img/tours/theme/safari-trails.png', link_url: '/holidays-list' },
              { title: 'Weekend', image_url: 'assets/img/tours/theme/weekend.png', link_url: '/holidays-list' },
              { title: 'Youth Holidays', image_url: 'assets/img/tours/theme/youth-holidays.png', link_url: '/holidays-list' },
            ]).map((item, index) => (
              <div key={index}>
                <a href={item.link_url || "/holidays-list"} target={item.link_url?.startsWith('/') ? "_self" : "_blank"} rel="noreferrer">
                  <img src={item.image_url} alt={item.title} />
                  <h5 className="holiday-theme-name">{item.title}</h5>
                </a>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default SlidersHolidays;
